import { Link } from "react-router";
import { ACCOUNT_REQUIRED_MESSAGE } from "@townsy/contracts";

/**
 * Where "Sign up (18+) to play" leads: the account page, asking for its Create account tab. (The account page opens on
 * Sign in today; `tab=signup` is the request for the sign-up tab, see ADR-0048.)
 */
export const SIGN_UP_TO_PLAY_HREF = "/account?tab=signup";

/**
 * Betting needs an account (ADR-0048; founder 2026-10-27: "Betting needs an account"). Shown to a guest where the
 * betting controls would be: the server refuses a guest's wager anyway (ACCOUNT_REQUIRED), so the controls are not
 * offered. `watch` says what the guest can still do here.
 */
export function SignUpToPlay({ watch }: { watch: string }) {
  return (
    <div className="venue-signup" data-testid="venue-signup-to-play">
      <Link className="btn btn-primary btn-sm" to={SIGN_UP_TO_PLAY_HREF} data-testid="venue-signup-link">
        {ACCOUNT_REQUIRED_MESSAGE}
      </Link>
      <span className="small muted">{watch} Play chips are free and have no value.</span>
    </div>
  );
}
